/* @flow */

import { white } from '@e180/ui/lib/token/palette';

export default {
  group: {
    position: 'relative',
  },
  label: {
    position: 'relative',

    marginLeft: 30,
    paddingRight: 12,

    color: ({ accentColor }: Object) => accentColor,

    fontSize: 14,
    fontStyle: 'italic',
    fontWeight: 500,
    lineHeight: 1.2,
    WebkitFontSmoothing: 'antialiased',

    '&:before': {
      borderColor: 'inherit !important',
    },
    '&:after': {
      bottom: '0 !important',

      height: 'auto !important',

      color: 'inherit !important',

      backgroundColor: 'inherit !important',
    },
  },
  'label-isDisabled': {
    opacity: 0.5,

    pointerEvents: 'none',
  },
  subLabel: {
    display: 'block',
    flex: 1,

    /* For IE 11 to display properly */
    MsFlex: '1 0 auto',

    color: `${white} !important`,
  },
};
